import { render, staticRenderFns } from "./purchase-chart.vue?vue&type=template&id=7aede640&scoped=true"
import script from "./purchase-chart.vue?vue&type=script&lang=js"
export * from "./purchase-chart.vue?vue&type=script&lang=js"
import style0 from "./purchase-chart.vue?vue&type=style&index=0&id=7aede640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aede640",
  null
  
)

export default component.exports